module.exports = __webpack_public_path__ + "images/pages/for_business/sp/sec03_c4f4926aa3b1dd5bc4fb4d76d9d3ec2c.jpg";